import React from 'react';
import cx from 'classnames';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import {ArrowLeftIcon} from '@material-ui/pickers/_shared/icons/ArrowLeftIcon';
import {ArrowRightIcon} from '@material-ui/pickers/_shared/icons/ArrowRightIcon';

export interface ArrowSwitcherProps extends React.HTMLProps<HTMLDivElement> {
    isLeftDisabled: boolean;
    isLeftHidden?: boolean;
    isRightDisabled: boolean;
    isRightHidden?: boolean;
    onLeftClick: () => void;
    onRightClick: () => void;
}

export const useStyles = makeStyles(
    theme => ({
        root: {},
        iconButton: {
            zIndex: 1
        },
        hidden: {
            visibility: 'hidden'
        }
    }),
    {name: 'MuiPickersArrowSwitcher'}
);

const leftArrowIcon = <ArrowLeftIcon />;
const rightArrowIcon = <ArrowRightIcon />;

const PureArrowSwitcher = React.forwardRef<HTMLDivElement, ArrowSwitcherProps>((props, ref) => {
    const {
        isLeftDisabled,
        isLeftHidden,
        isRightDisabled,
        isRightHidden,
        onLeftClick,
        onRightClick,
        children
    } = props;
    const classes = useStyles();
    const theme = useTheme();
    const isRtl = theme.direction === 'rtl';

    return (
        <>
            <IconButton
                data-mui-test="previous-arrow-button"
                size="small"
                disabled={isLeftDisabled}
                onClick={onLeftClick}
                className={cx(classes.iconButton, {
                    [classes.hidden]: isLeftHidden
                })}>
                {isRtl ? rightArrowIcon : leftArrowIcon}
            </IconButton>
            {children}
            <IconButton
                data-mui-test="next-arrow-button"
                size="small"
                disabled={isRightDisabled}
                onClick={onRightClick}
                className={cx(classes.iconButton, {
                    [classes.hidden]: Boolean(isRightHidden)
                })}>
                {isRtl ? leftArrowIcon : rightArrowIcon}
            </IconButton>
        </>
    );
});

PureArrowSwitcher.displayName = 'ArrowSwitcher';

export default React.memo(PureArrowSwitcher);
